import React, { type ReactElement } from 'react';
import { Sections, type SubscriberProps } from '@atlassian/jira-portfolio-3-common';
import type { View } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/views/types';
import { SECTION_KEYS } from '@atlassian/jira-portfolio-3-portfolio/src/common/view/constant';

/**
 * Helper FAAC to respond to timeline changes in <Section's /> private state
 */

export type TimelineWidthSubscriberProps = {
	isCollapsed: boolean;
	timelineWidth: number | undefined;
	timelineMinWidth: number | undefined;
};

export type Props = {
	activeView: View;
	children?: (arg1: TimelineWidthSubscriberProps) => ReactElement;
};

const TimelineWidthSubscriber = ({ activeView, children }: Props) => (
	<Sections.Subscriber>
		{/* @ts-expect-error - TS2322 - Type '({ sectionsData }: SubscriberProps) => React.ReactElement<any, string | React.JSXElementConstructor<any>> | null' is not assignable to type '(((arg1: SubscriberProps) => ReactElement<any, string | JSXElementConstructor<any>>) & (boolean | ReactChild | ReactFragment | ReactPortal | null)) | undefined'. */}
		{({ sectionsData }: SubscriberProps) => {
			const activeTimelineSection = sectionsData?.[`view-${activeView?.id}-${SECTION_KEYS.MAIN}`];

			const timelineMinWidth = activeTimelineSection?.minWidths?.['timeline-column'];
			const timelineWidth = activeTimelineSection?.widths?.['timeline-column'];

			const isCollapsed =
				timelineMinWidth != null && timelineWidth != null && timelineWidth <= timelineMinWidth;

			if (isCollapsed) {
				return null;
			}

			return children ? children({ isCollapsed, timelineWidth, timelineMinWidth }) : null;
		}}
	</Sections.Subscriber>
);

export default TimelineWidthSubscriber;
